import { Modal } from "reactstrap";
import styled from "styled-components";

export const ModalCreate = styled(Modal)``;
